/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  shipping-billing-actions.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali (H175591)
 *
 * @Date         : Sep 13, 2019
 *
 * @Version      : Version 1.0
 * *
 * By            : Madhu Gali (H175591)
 * On            : Sep 13, 2019
 * Description   : ASDS-1170: User email automatically populated.
 *
 *   By            : sivateja
 * On            : Nov 8, 2019
 * Description   : ASDS-167: removed un necessary functions
 *
 * By            	: Madhu Gali
 * On            	:  Dec 18, 2019
 * Description      : ASDS-584
 *
 * By            : Madhu Gali - H175591
 * On            : Feb 19, 2020
 * Description   : ASDS-2355
 *
 * By            : H224423
 * On            : Mar 23, 2020
 * Description   : ASDS-1052 - Forge Header Logout Functionality. Added method to reset user validation data.
 *
 * By            : E807958
 * On            : Mar 30, 2020
 * Description   : ASDS-1763
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
 ******************************************************************************/

import Reducer from './reducer';
import { AsdsReduxAction, AsdsReducerObject } from '../../../../../types';
import CheckoutActionConstants from '../../constants/checkoutActionConstants';
import { createReducer } from '../utils/redux-util';
import { logInfo } from '../../../../utils/console-utility';

/**
 * @author H175591
 * @description This reducer class consists of all the reducers that deal with user data validation.
 * on redux configuration.
 */
class UserValidationReducer extends Reducer {

    static setLoggedInUserInfo(state, action: AsdsReduxAction): AsdsReducerObject {
        logInfo('in setLoggedInUserInfo reducer', state);
        return {
            isSuccess: true,
            isFetching: false,
            payload: {
                ...state.payload,
                userInfo: action.payload.response && { ...action.payload.response }
            }
        };
    }

    static checkSFDCStatus(state, action: AsdsReduxAction): AsdsReducerObject {
        logInfo('inside setSFDCCaseStatus reducer', state);
        logInfo(action.payload.response);
        return {
            isSuccess: true,
            isFetching: false,
            payload: { ...state.payload, userAddrDetails: action.payload.response }
        };
    }

    static setUserAccessInfo(state, action: AsdsReduxAction): AsdsReducerObject {
        logInfo('in setUserAccessInfo reducer', state);
        return {
            ...state,
            isSuccess: true,
            isFetching: false,
            payload: {
                ...state.payload,
                userSessionInfo: {
                    accessCode: action.payload.response.accessCodeObj,
                    accessToken: action.payload.response.accessTokenObj,
                    isForgeEnv: action.payload.response.isForgeEnv,
                }
            }
        };
    }

    static setForgeUserInfo(state, action: AsdsReduxAction): AsdsReducerObject {
        logInfo('in setForgeUserInfo reducer', state);
        return {
            isSuccess: true,
            isFetching: false,
            payload: {
                ...state.payload,
                userInfo: action.payload.response
            }
        };
    }

    static setASDSAccessInfo(state, action: AsdsReduxAction): AsdsReducerObject {
        return {
            ...state,
            payload: {
                ...state.payload,
                asdsAccess: action.payload.results,
            }
        };
    }

    static setASDSUserRole(state, action: AsdsReduxAction): AsdsReducerObject {
        return {
            ...state,
            payload: {
                ...state.payload,
                isAdminUser: action.payload.results,
            }
        };
    }

    static resetUserInfo(): AsdsReducerObject {
        return initialState;
    }

}
/**
 * This handler deals with mapping of actions to reducer methods.
 * @type {{}}
 */
const userHandlers = {
    [CheckoutActionConstants.SET_LOGGED_IN_USER_INFO]: UserValidationReducer.setLoggedInUserInfo,
    [CheckoutActionConstants.SET_SFDC_CASE_STATUS]: UserValidationReducer.checkSFDCStatus,
    [CheckoutActionConstants.SET_USER_ACCESS_INFO]: UserValidationReducer.setUserAccessInfo,
    [CheckoutActionConstants.SET_ASDS_ACCESS_INFO]: UserValidationReducer.setASDSAccessInfo,
    [CheckoutActionConstants.SET_ASDS_USER_ROLE]: UserValidationReducer.setASDSUserRole,
    [CheckoutActionConstants.RESET_USER_INFO]: UserValidationReducer.resetUserInfo
}

const initialState = {
    isFetching: true,
    isSuccess: false,
    payload: {
        asdsAccess: false,
        isAdminUser: false,
        userInfo: {
            email: '',
            family_name: '',
            given_name: '',
            sub: '',
            avatar: "",
            customer: "",
            customer_sub: "",
            name: "",
            preferred_username: "",
            sid: "",
        },
        userSessionInfo: {
            isForgeEnv: false,
            accessCode: {
                code: "",
                scope: "",
                state: "",
            },
            accessToken: {
                access_token: "",
                expires_in: 0,
                id_token: "",
                scope: "",
                token_type: "",
                refresh_token: ''
            }
        },
        userRole: false,
        caseDetails: {},
        soldTo: {},
        shipTo: {},
        userAddrDetails: {
            results: {
                account: {
                    accounts: [
                        {
                            accountId: "",
                            customerName: "",
                            sapShipTo: [
                                {
                                    addressLine1: "",
                                    addressId: "",
                                    city: "",
                                    country: "",
                                    countryCode: "",
                                    sapNumber: "",
                                    state: "",
                                    zip: "",
                                }
                            ],
                            sapSoldTo: [
                                {
                                    addressLine1: "",
                                    addressId: "",
                                    city: "",
                                    country: "",
                                    countryCode: "",
                                    sapNumber: "",
                                    state: "",
                                    zip: "",
                                }
                            ],
                        }
                    ]
                },
                caseDetails: [],
                isAdmin: false,  // Dummy value. not being used any more after migration of backend to Forge API
                prevSelectedAddress: {},
            },
            status: 0,
        },
    },
};

export const userValidationData = createReducer(initialState, userHandlers);